/* Libs */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import VimeoPlayer from '@livingsecurity/react-vimeo';

/* Utils */

import { isEmpty } from 'utils/validation';

/* Components */

import { BigTitle, Button } from 'components';

/* Constants */

import { GAME_STEP_TITLES } from '_constants';

/* Styles */

import * as Styled from './styles';

function Debriefing({
  hasNextStep,
  vimeoId,
  title,
  text,
  next,
  isDarkMode,
}) {
  const [videoNotFound, setVideoNotFound] = useState(isEmpty(vimeoId));
  if (isEmpty(text) && isEmpty(vimeoId) && isEmpty(title)) next();
  if (videoNotFound && isEmpty(text) && isEmpty(title)) next();
  return (
    <Styled.Wrapper isDarkMode={isDarkMode}>
      <BigTitle>
        {title || GAME_STEP_TITLES.debriefing}
      </BigTitle>
      <Styled.Content>
        {
          videoNotFound
            ? <div dangerouslySetInnerHTML={{ __html: text }} />
            : (
              <VimeoPlayer
                videoId={vimeoId}
                autoplay
                onError={e => setVideoNotFound(true)}
              />
            )
        }
      </Styled.Content>
      <Styled.Actions>
        <Button
          onClick={next}
        >
          {' '}
          {`${hasNextStep ? 'Next' : 'Exit'}`}
          {' '}

        </Button>
      </Styled.Actions>
    </Styled.Wrapper>
  );
}

/* Debriefing type of props */

Debriefing.propTypes = {
  hasNextStep: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  next: PropTypes.func.isRequired,
};

export default Debriefing;
